export default __webpack_public_path__ + "static/media/search.5283e8f0.svg";